<div class="wrap">
    <div class="top-row">

        <mat-tab-group class="tabGroup"
                       color="accent"
                       animationDuration="0ms"
                       [selectedIndex]="selectedTabIndex"
                       (selectedTabChange)="onTabChange($event)">

            <mat-tab label="Payment Requests"></mat-tab>
            <mat-tab label="Expected Funds"></mat-tab>
            <mat-tab label="Transfer Requests"></mat-tab>
            <mat-tab label="Journal Requests"></mat-tab>

            <!--<mat-tab>
                <ng-template mat-tab-label>
                    <div class="tab-label">
                        Payment Requests
                        @if(selectedTabIndex === 0 && paymentRequestCount > 0){
                        <span class="count-badge">
                            {{ paymentRequestCount }}
                        </span>
                        }
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="tab-label">
                        Expected Funds
                        @if (selectedTabIndex === 1 && expectedRequestCount > 0){
                        <span class="count-badge">
                            {{ expectedRequestCount }}
                        </span>
                        }
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="tab-label">
                        Transfer Requests
                        @if(selectedTabIndex === 2 && transferRequestCount > 0){
                        <span class="count-badge">
                            {{ transferRequestCount }}
                        </span>
                        }
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="tab-label">
                        Journal Requests
                        @if(selectedTabIndex === 3 && journalRequestCount > 0){
                        <span class="count-badge">
                            {{ journalRequestCount }}
                        </span>
                        }
                    </div>
                </ng-template>
            </mat-tab>-->
        </mat-tab-group>

        <div class="action-buttons">
            <xp-download-status></xp-download-status>
            <button mat-raised-button color="primary" class="action2-button" (click)="resetFilters()">
                Reset Filters
            </button>

            <button mat-raised-button color="accent"
                    [disabled]="downloadBusy || selectedCount === 0"
                    (click)="downloadSelectedAsPdf()"
                    matTooltip="Download the selected requests, on every page, as a ZIP of PDFs">
                <mat-icon>download</mat-icon>
                Download Selected ({{ selectedCount }})
            </button>

            <button mat-raised-button color="primary" class="action-button" [disabled]="isExporting" (click)="exportData()">
                Export
            </button>
        </div>
    </div>

    <router-outlet (activate)="onOutletActivate($event)"></router-outlet>
</div>
